import type { TranslationKeys } from './keys';

export const ru = {
  // App title and description
  appTitle: "Дневник путешествий",
  appDescription: "Сохраняйте и планируйте свои путешествия",
  
  // Tab names
  myFlights: "Авиа",
  carTrips: "Авто",
  transport: "Транспорт",
  trips: "Поездки",
  buses: "Автобус",
  trains: "Поезд",
  ferries: "Паром",
  addBusTrip: "Добавить автобус",
  addTrainTrip: "Добавить поезд",
  addFerryTrip: "Добавить паром",
  editBusTrip: "Редактировать автобус",
  editTrainTrip: "Редактировать поезд",
  editFerryTrip: "Редактировать паром",
  busOperator: "Перевозчик",
  trainOperator: "Перевозчик",
  ferryOperator: "Оператор",
  busNumber: "Номер рейса",
  trainNumber: "Номер поезда",
  ferryNumber: "Номер рейса",
  notes: "Заметки",
  analytics: "Аналитика",
  statistics: "Статистика",
  routeMap: "Карта",
  planning: "План",
  journeys: "Дневник",
  
  // Authentication
  login: "Вход",
  loginSubtitle: "Введите данные для входа",
  register: "Регистрация",
  registerSubtitle: "Введите данные для создания аккаунта",
  logout: "Выход",
  email: "Электронная почта",
  password: "Пароль",
  confirmPassword: "Подтвердите пароль",
  loginWithEmail: "Войти с помощью почты",
  loginWithGoogle: "Войти через Google",
  createAccount: "Создать аккаунт",
  orContinueWith: "Или продолжить с помощью",
  dontHaveAccount: "Нет аккаунта?",
  alreadyHaveAccount: "Уже есть аккаунт?",
  forgotPassword: "Забыли пароль?",
  forgotPasswordTitle: "Восстановление пароля",
  forgotPasswordSent: "Если аккаунт с такой почтой существует, мы отправили ссылку для сброса пароля.",
  resetPassword: "Сбросить пароль",
  confirmEmailTitle: "Подтверждение почты",
  confirmEmailSent: "Письмо с ссылкой для подтверждения отправлено на вашу почту.",
  passwordsDoNotMatch: "Пароли не совпадают",
  passwordTooShort: "Пароль должен содержать не менее 6 символов",
  resetPasswordSubtitle: "Введите новый пароль ниже.",
  resetPasswordSuccess: "Пароль успешно изменён. Перенаправляем на вход…",
  resetPasswordInvalidLink: "Недействительная или отсутствующая ссылка. Запросите новую.",
  missingResetToken: "Отсутствует токен сброса",
  resetFailed: "Не удалось сбросить пароль",
  backToApp: "Вернуться в приложение",
  goToApp: "Перейти в приложение",
  forgotPasswordHint: "Введите email — мы отправим ссылку для сброса пароля.",
  requestFailed: "Запрос не выполнен",
  confirmingEmail: "Подтверждаем ваш email…",
  confirmEmailSuccessSubtitle: "Можно закрыть эту страницу и войти в аккаунт.",
  confirmEmailError: "Ошибка",
  error: "Ошибка",
  loading: "Загрузка...",
  
  // Card titles
  totalFlights: "Всего рейсов",
  totalDistance: "Общее расстояние",
  averagePrice: "Средняя цена",
  totalSpent: "Всего потрачено",
  totalTrips: "Всего поездок",
  totalExpenses: "Общие расходы",
  fuelConsumption: "Расход топлива",
  fuelExpenses: "Расходы на топливо",
  roadExpenses: "Расходы на дороги",
  visitedCities: "Посещённые города",
  
  // Units
  km: "км",
  milesUnit: "Мили",
  liters: "л",
  litersPerHundredKm: "л/100км",
  roadNumbers: "Номера дорог",
  hours: "ч",
  
  // Status messages
  calculatingDistance: "Расчет расстояния...",
  
  // Analytics / Statistics titles
  flightsByMonth: "Рейсы по месяцам",
  flightsPerYear: "Рейсы по годам",
  flightsPerWeekday: "Рейсы по дням недели",
  yearsOfFlying: "лет в небе",
  chartCount: "Кол-во",
  carTripsByWeekday: "Поездки по дням недели",
  carTripsPerYear: "Поездки по годам",
  tripsByMonth: "Поездки по месяцам",
  topCities: "Топ городов",
  topOperators: "Топ перевозчиков",
  totalCities: "всего городов",
  totalOperators: "всего перевозчиков",
  yearsOnTheRoad: "лет в пути",
  totalTimeOnRoad: "Время в пути",
  totalTimeInFlight: "Время в полёте",
  daysUnit: "дней",
  monthsUnit: "мес.",
  topAirports: "Топ аэропортов",
  topAirlines: "Топ авиакомпаний",
  topAircraft: "Топ ВС",
  topRoutes: "Топ маршрутов",
  topCountries: "Топ стран",
  totalAirports: "всего аэропортов",
  totalAirlines: "всего авиакомпаний",
  totalAircraft: "всего типов ВС",
  totalRoutes: "всего маршрутов",
  totalCountries: "всего стран",
  flightsCount: "рейсов",
  domesticCount: "внутренних",
  internationalCount: "международных",
  airlines: "Авиакомпании",
  flightClasses: "Класс",
  carsByYear: "Автомобили по годам выпуска",
  carBrands: "Марки автомобилей",
  fuelTypes: "Типы топлива",
  mileageByMonth: "Пробег по месяцам (км)",
  fuelConsumptionByCarBrand: "Расход топлива по маркам авто (л)",
  fuelExpensesByMonth: "Расходы на топливо по месяцам (₽)",
  statsPeriodAll: "Всё время",
  statsPeriodYear: "Этот год",
  statsPeriodRolling12: "12 месяцев",
  statsPeriodCustom: "Период",
  statsPeriodFrom: "С",
  statsPeriodTo: "По",
  statsTagAll: "Все поездки",
  statsTagFilter: "Тег поездки",
  statsCountries: "Страны",
  statsGeneral: "Общее",
  statsFunFacts: "Интересные факты",
  statsFunFactsDistance: "Расстояние",
  statsFunFactsCost: "Стоимость",
  statsFunFactsTime: "Время",
  statsSpendByMode: "Траты по категориям",
  statsDistanceByMode: "Километры по видам",
  statsByCategory: "Сводка по категориям",
  visitedCountriesTitle: "Посещённые страны",
  visitedCountriesCount: "Отмечено стран",
  visitedCountriesCountUn: "Список ООН",
  visitedCountriesSync: "Обновить из поездок",
  visitedCountriesHint: "Страны подтягиваются автоматически из поездок. Интенсивность цвета на карте — по числу посещённых регионов в стране.",
  visitedCountriesResidence: "Страна проживания",
  visitedCountriesPercent: "От государств — членов ООН",
  visitedCountriesFreelyAssociated: "Свободно ассоциированные государства",
  visitedCountriesKingdomTerritories: "Территории и страны в составе королевств",
  visitedCountriesSpecialAdministrativeRegions: "Особые административные регионы",
  visitedCountriesDisputedTerritories: "Спорные территории",
  visitedCountriesPartiallyRecognized: "Частично признанные государства",
  visitedCountriesDependentTerritories: "Зависимые территории",
  visitedCountriesSpecialInternationalStatus: "Территории и регионы с особым международно-правовым статусом",
  visitedCountriesSearch: "Поиск страны…",
  visitedCountriesSearchEmpty: "Ничего не найдено",
  visitedCountriesByRegion: "Регионы",
  visitedCountriesNoPlaces: "Города не указаны",
  visitedCountriesZoomIn: "Приблизить",
  visitedCountriesZoomOut: "Отдалить",
  visitedCountriesReset: "Сбросить масштаб",
  visitedCountriesSubdivisions: "Регионы / штаты",
  visitedCountriesSubdivisionStats: "Регионы и штаты",
  visitedCountriesLifeExpectancy: "Средняя продолжительность жизни",
  visitedCountriesPopulation: "Население",
  visitedCountriesCapital: "Столица",
  visitedCountriesPeaceIndex: "Индекс мира (GPI)",
  visitedCountriesInterestingFacts: "Интересные факты",
  
  // Settings
  settings: "Настройки",
  car: "Автомобиль",
  other: "Другое",
  settingsPreferences: "Предпочтения",
  settingsGarage: "Гараж",
  settingsGarageHint: "Авто для новых поездок и расчёта расхода",
  settingsResidenceCountry: "Страна проживания",
  settingsResidenceCountryHint: "Для визовых правил в планах поездок (гражданство / ПМЖ)",
  carYear: "Год",
  defaultCar: "По умолчанию",
  carBrand: "Марка автомобиля",
  fuelConsumptionRate: "Расход топлива (л/100км)",
  fuelType: "Тип топлива",
  currency: "Валюта",
  language: "Язык",
  distanceUnit: "Единица расстояния",
  kilometers: "Километры",
  addCar: "Добавить автомобиль",
  deleteCar: "Удалить автомобиль",
  selectCar: "Выберите автомобиль",
  theme: "Тема",
  lightTheme: "Светлая",
  darkTheme: "Темная",
  
  // Fuel types
  gasoline: "Бензин",
  diesel: "Дизель",
  gas: "Газ",
  electric: "Электро",
  
  // Currencies
  ruble: "₽ (Рубль)",
  dollar: "$ (Доллар)",
  euro: "€ (Евро)",
  
  // Languages
  russian: "Русский",
  english: "English",
  
  // Buttons
  cancel: "Отмена",
  save: "Сохранить",
  addFlight: "Добавить рейс",
  addTrip: "Добавить поездку",
  newTrip: "Новая поездка",
  carTripDay: "День",
  carTripDays: "Дни",
  addCarTripDay: "Добавить день",
  carTripDaysCount: "{n} дней",
  addWaypoint: "Добавить промежуточную точку",
  removeWaypoint: "Удалить точку",
  viewTrip: "Просмотреть",
  editTrip: "Редактировать",
  editFlight: "Редактировать рейс",
  deleteTrip: "Удалить",
  saveChanges: "Сохранить изменения",
  close: "Закрыть",
  confirmDeleteTrip: "Вы уверены, что хотите удалить эту поездку?",
  confirmDeleteFlight: "Удалить этот рейс?",
  borderCrossing: "Граница",

  // Form labels
  date: "Дата",
  dateOfDeparture: "Дата вылета",
  dateFrom: "Дата с",
  dateTo: "Дата по",
  filter: "Фильтр",
  filterByTag: "Фильтр по тегу",
  priceFrom: "Цена от",
  priceTo: "Цена до",
  searchFlights: "Поиск по дате, тегу, аэропорту, городу, авиакомпании…",
  filterChipsHint: "Чипы: тег поездки, год или город — Enter чтобы добавить",
  filterChipsPlaceholder: "Год, тег или город…",
  resetFilter: "Сбросить",
  applyFilter: "Применить",
  noFilterResults: "Ничего не найдено",
  flightNumber: "Номер рейса",
  departureCity: "Город отправления",
  arrivalCity: "Город прибытия",
  departureAirport: "Аэропорт вылета",
  arrivalAirport: "Аэропорт прилёта",
  airportPlaceholder: "Город (код)",
  airportDescriptionUnavailable: "Описание недоступно",
  departureTime: "Время вылета",
  arrivalTime: "Время прилёта",
  duration: "Время в пути",
  airline: "Авиакомпания",
  aircraftType: "Тип ВС",
  aircraftReg: "Бортовой номер",
  originCity: "Город отправления",
  destinationCity: "Город назначения",
  originStation: "Станция отправления",
  destinationStation: "Станция назначения",
  trainDepartureTime: "Отправление",
  trainArrivalTime: "Прибытие",
  waypoints: "Промежуточные точки",
  waypointCity: "Промежуточный город",
  distance: "Расстояние",
  estimatedTime: "Расчетное время",
  uploadBoardingPass: "Загрузить посадочный / квитанцию",
  parsingBoardingPass: "Распознаём документ…",
  boardingPassParsed: "Данные подставлены из документа",
  boardingPassParseFailed: "Не удалось распознать документ. Попробуйте другое фото или PDF.",
  boardingPassHint: "Фото или PDF посадочного талона / маршрутной квитанции",
  ticketParseHint: "Фото или PDF билета",
  ticketParseHintBus: "Фото или PDF билета автобуса",
  ticketParseHintTrain: "Фото или PDF билета поезда",
  ticketParseHintFerry: "Фото или PDF билета парома",
  ticketParsed: "Данные из билета заполнены",
  ticketParseFailed: "Не удалось распознать билет",
  boardingPassSegmentsTitle: "Несколько сегментов",
  boardingPassAddAll: "Добавить все рейсы",
  boardingPassUseOne: "Подставить в форму",
  boardingPassSegmentsHint: "Цена разделена поровну между сегментами",
  boardingPassAllAdded: "Все сегменты добавлены",
  autoFill: "Дозаполнить",
  getFlightData: "Получить данные",
  next: "Далее",
  back: "Назад",
  fuelAmount: "Объем топлива (л)",
  fuelPrice: "Цена топлива",
  tollRoadCost: "Платные дороги (₽)",
  noTollRoads: "Нет платных участков",
  avoidFerries: "Избегать паромов",
  avoidTollRoads: "Избегать платных дорог",
  buildingRoute: "Построение маршрута…",
  accommodationName: "Проживание (название)",
  accommodationCost: "Стоимость проживания",
  hotelName: "Название гостиницы",
  add: "Добавить участок",
  remove: "Удалить",
  cost: "Стоимость (₽)",
  flightPrice: "Стоимость перелёта",
  required: "*",
  selectType: "Выберите тип",
  tag: "Путешествие",
  flightClass: "Класс перелёта",
  economy: "Эконом",
  premiumEconomy: "Комфорт (премиум эконом)",
  business: "Бизнес",
  first: "Первый класс",
  flightLabel: "Рейс",
  timeLabel: "Время",
  timeInFlight: "Время в полёте",
  internationalFlight: "Международный",
  domesticFlight: "Внутренний",
  flightScope: "Тип перелёта",

  // Helper texts
  distanceAutoCalculated: "Расстояние рассчитывается автоматически с помощью MapQuest",
  timeAutoCalculated: "Время в пути рассчитывается автоматически с помощью MapQuest",
  
  // Modal titles
  addNewFlight: "Добавить новый рейс",
  addNewTrip: "Добавить новую поездку",
  tripDetails: "Детали поездки",
  route: "Маршрут",
  tripInfo: "Информация о поездке",
  totalCost: "Общая стоимость",
  
  // Other
  mapInDevelopment: "Карта маршрутов в разработке",
  inDevelopment: "В разработке",
  addFirstFlight: "Добавьте первый рейс",
  mapModeAviation: "Авиа",
  mapModeCar: "Авто",
  mapAllYears: "Все годы",
  mapNoFlights: "Нет рейсов для отображения",
  mapSkippedCoords: "Без координат: {n}",
  mapSelectYear: "Выберите год",
  trainDetails: "Детали поезда",
  trainStops: "Остановки",
  trainCarrier: "Перевозчик",
  trainBrandedName: "Тип поезда",
  noTrainStops: "Остановки не найдены",

  planningNewTrip: "Новая поездка",
  planningHistory: "История планов",
  planningDestination: "Куда едем",
  planningMustSee: "Что обязательно посмотреть",
  planningInterests: "Интересы",
  planningTransport: "Транспорт",
  planningTravelers: "Путешественников",
  planningBudgetMin: "Бюджет от",
  planningBudgetMax: "Бюджет до",
  planningBudget: "Бюджет",
  planningPace: "Темп поездки",
  planningAccommodation: "Жильё",
  planningWithChildren: "С детьми",
  planningAccessibility: "Доступность / питание",
  planningAdditionalNotes: "Дополнительно",
  planningDatesFlexible: "Гибкие даты",
  planningGetSuggestions: "Получить варианты",
  planningGenerating: "Генерируем план…",
  planningResults: "Варианты поездки",
  planningNoResults: "Нет вариантов",
  planningNoHistory: "Пока нет сохранённых планов",
  planningVariants: "вар.",
  planningDeleteConfirm: "Удалить этот план?",
  planningItinerary: "Маршрут по дням",
  planningDay: "День",
  planningTransportTips: "Советы по транспорту",
  planningInterestCulture: "Культура",
  planningInterestNature: "Природа",
  planningInterestFood: "Еда",
  planningInterestNightlife: "Ночная жизнь",
  planningInterestMuseums: "Музеи",
  planningInterestBeaches: "Пляжи",
  planningInterestHiking: "Походы",
  planningInterestShopping: "Шопинг",
  planningInterestArchitecture: "Архитектура",
  planningInterestLocalLife: "Местная жизнь",
  planningInterestPhoto: "Фото",
  planningInterestSport: "Спорт",
  planningTransportFlight: "Самолёт",
  planningTransportTrain: "Поезд",
  planningTransportCar: "Авто",
  planningTransportBus: "Автобус",
  planningTransportFerry: "Паром",
  planningTransportMixed: "Смешанный",
  planningTransportAny: "Любой",
  planningPaceRelaxed: "Спокойный",
  planningPaceModerate: "Умеренный",
  planningPaceActive: "Активный",
  planningPaceIntensive: "Интенсивный",
  planningAccommodationHotel: "Отель",
  planningAccommodationHostel: "Хостел",
  planningAccommodationApartment: "Апартаменты",
  planningAccommodationCamping: "Кемпинг",
  planningAccommodationAny: "Любое",
  planningTravelStyle: "Тип отдыха",
  planningStyleDownshifter: "Бэкпекер",
  planningStyleBackpacker: "Бэкпекер",
  planningStyleBudget: "Бюджет",
  planningStyleMidrange: "Комфорт",
  planningStyleElite: "Элита",
  planningStyleAdventure: "Приключения",
  planningStyleWellness: "Велнес",
  planningStyleFamily: "Семья",
  planningStyleRomantic: "Романтика",
  planningStyleNomad: "Номад",
  planningStyleDownshifterHint: "Хостелы, локально, дёшево",
  planningStyleBackpackerHint: "Хостелы, локально, дёшево",
  planningStyleBudgetHint: "Экономия без крайностей",
  planningStyleMidrangeHint: "Баланс цены и удобства",
  planningStyleEliteHint: "Люкс, сервис, премиум",
  planningStyleAdventureHint: "Актив, природа, вызов",
  planningStyleWellnessHint: "Спа, тишина, восстановление",
  planningStyleFamilyHint: "С детьми, удобно и безопасно",
  planningStyleRomanticHint: "Для двоих, атмосфера",
  planningStyleNomadHint: "Wi‑Fi, коворкинги, гибкость",
  planningHotels: "Отели",
  planningUsefulLinks: "Полезные ссылки",
  planningCostBreakdown: "Смета",
  planningFoodTips: "Еда",
  planningPracticalTips: "Практика",
  planningOpenLink: "Открыть",
  planningProTips: "Полезные советы",
  planningCountryInfo: "Справка",
  planningAboutCountry: "О стране",
  planningAboutRegion: "О регионе",
  planningAboutRegions: "О регионах",
  planningRegionClimate: "Климат",
  planningRegionFood: "Еда региона",
  planningRegionHighlights: "Что посмотреть",
  planningSafety: "Безопасность",
  planningLifeExpectancy: "Продолжительность жизни",
  planningPopulation: "Население",
  planningCapital: "Столица",
  planningPeaceIndex: "Индекс мира (GPI)",
  planningInterestingFacts: "10 интересных фактов",
  planningConnectivity: "Связь / интернет",
  planningCurrency: "Валюта",
  planningPlugs: "Розетки",
  planningLanguage: "Язык",
  planningVisa: "Виза",
  planningVisaEmbassy: "Посольство / консульство",
  planningHealth: "Здоровье",
  planningUsefulPhrases: "Разговорник",
  planningPhrasebook: "Разговорник",
  planningGroceryCosts: "Средние цены на продукты",
  planningFuelPrice: "Цена бензина",
  planningLodging: "Ночлег",
  planningCamping: "Кемпинг",
  planningHostel: "Хостел",
  planningApartment: "Апартаменты",
  planningSouvenirs: "Сувениры",
  planningDuration3d: "3 дня",
  planningDuration2d: "2 дня",
  planningDuration1w: "Неделя",
  planningDuration2w: "2 недели",
  planningDuration1m: "Месяц",
  planningTabOverview: "Обзор",
  planningTabDays: "По дням",
  planningDriveKm: "Пробег за день",
  planningOpenMap: "На карте",
  planningHowToGet: "Как добраться",
  planningTabRoad: "Куда поехать",
  planningTabCountries: "Страны",
  planningNoRoadStops: "Маршрут остановок пока пуст — выберите транспорт «машина» или смешанный и сгенерируйте план заново",
  planningVisited: "Уже был",
  planningMarkVisited: "Отметить «был»",
  planningUnmarkVisited: "Снять отметку",
  planningVisitedHint: "Отмеченные места сохраняются и исключаются при следующей генерации",
  planningExcludePlaces: "Уже был — исключить",
  planningExcludePlacesHint: "Эти места не попадут в новый план",
  planningAddExclude: "Добавить",
  planningStopTourist: "Туристическое",
  planningStopLocal: "Локальное",
  planningStopViewpoint: "Смотровая",
  planningStopFood: "Еда",
  planningStopNature: "Природа",
  planningStopTown: "Город",
  planningStopOther: "Место",
  planningRoadConditions: "Дороги",
  planningFuelNotes: "Топливо по пути",
  planningScenicHighlights: "Красивые места маршрута",
  planningRoadTips: "Советы по дороге",
  planningStopBestTime: "Когда лучше",
  planningStopParking: "Парковка",
  planningStopFoodNearby: "Где поесть рядом",
  planningStopPhoto: "Для фото",
  planningFree: "бесплатно",
  planningHistoryToggle: "История планов",
  planningModeGeneral: "Обычный план",
  planningModeRoad: "Автомаршрут",
  planningModeRoadHint: "Старт → финиш: маршрут по дням с заездами",
  planningModeWeekend: "Выходные",
  planningModeWeekendHint: "Дом + база на выходные, в конце возврат",
  planningWeekendBase: "База выходных",
  planningWeekendHome: "Дом (возврат)",
  planningWeekendBaseHint: "Например: Санкт-Петербург",
  planningWeekendHomeHint: "Откуда уезжаете и куда возвращаетесь",
  planningRoadStart: "Старт",
  planningRoadEnd: "Финиш",
  planningRoadStartHint: "Например: Киров",
  planningRoadEndHint: "Например: Нижний Новгород",
  planningMultiCountry: "Несколько стран",
  planningDestinationHint: "Одна страна или маршрут: Италия → Словения → Хорватия",
  planningAddDestination: "Добавить",
  planningAddCountry: "Добавить страну",
  planningAddCity: "Добавить город",
  planningCountryName: "Страна",
  planningCityName: "Город",
  planningCities: "Города",
  planningNextStop: "Следующая точка",
  planningFreeTextHint: "Город, страна или регион — как угодно",
  planningFormHint: "Свободный текст — LLM сама поймёт маршрут",
  planningTripPurpose: "Цель поездки",
  planningPurposeLeisure: "Отдых",
  planningPurposeRomantic: "Романтика",
  planningPurposeBusiness: "Бизнес",
  planningPurposeCultural: "Культура",
  planningSeason: "Сезон",
  planningSeasonAny: "Любой",
  planningSeasonSpring: "Весна",
  planningSeasonSummer: "Лето",
  planningSeasonAutumn: "Осень",
  planningSeasonWinter: "Зима",

  journeysSummary: "Дневник",
  journeysAdd: "Добавить путешествие",
  journeysAddTitle: "Новое путешествие",
  journeysName: "Название",
  journeysDateFrom: "Дата начала",
  journeysDateTo: "Дата окончания",
  journeysDateUnknown: "Неизвестно",
  journeysEditDates: "Изменить даты путешествия",
  journeysDateOpenEnded: "Без даты окончания",
  journeysCreated: "Путешествие создано",
  journeysNoTags: "Пока нет путешествий. Нажмите «Добавить путешествие» или добавьте «Путешествие» к рейсу, авто, автобусу или поезду.",
  journeysFlights: "рейсов",
  journeysCarTrips: "поездок",
  journeysDiary: "Дневник",
  journeysDayEntry: "Что было в этот день",
  journeysSaveDay: "Сохранить",
  journeysVoiceStart: "Диктовать",
  journeysVoiceStop: "Стоп",
  journeysVoiceUnsupported: "Голосовой ввод не поддерживается в этом браузере",
  journeysBackToList: "Все путешествия",
  journeysRenameTag: "Переименовать тег",
  journeysRenameTagPlaceholder: "Новое название",
  journeysUntagged: "Без тега",
  journeysPickTrip: "Выберите путешествие",
  journeysEmptyDiary: "Пока нет записей — напишите первый день",
  journeysListening: "Слушаю…",
  journeysReport: "Отчёт",
  journeysReportGenerating: "Пишем отчёт…",
  journeysReportTitle: "Отчёт о поездке",
  journeysAddPhoto: "Добавить фото",
  journeysDeleteReport: "Удалить отчёт",
  journeysReportPdf: "PDF",
  journeysAlbum: "Альбом",
  journeysSetCover: "Обложка",
  journeysCover: "Обложка альбома",
  journeysExpenses: "Затраты",
  journeysExpenseTitle: "На что",
  journeysExpenseAmount: "Сумма",
  journeysExpenseAdd: "Добавить",
  journeysExpenseSave: "Сохранить",
  journeysExpenseCancel: "Отмена",
  journeysExpenseEdit: "Изменить",
  journeysExpenseEmpty: "Пока нет затрат",
  journeysExpenseCategory: "Категория",
  journeysCatFood: "Еда",
  journeysCatTransport: "Транспорт",
  journeysCatStay: "Жильё",
  journeysCatTickets: "Билеты",
  journeysCatSouvenirs: "Сувениры",
  journeysCatOther: "Другое",
  journeysSelectPhotos: "Выбрать фото",
  journeysWriteHint: "Расскажите, что видели и чувствовали — можно диктовать голосом",
  journeysEditingDay: "Редактирование дня",
  journeysNewDay: "Новая запись",
  journeysDaysShort: "дней",
  journeysPhotosShort: "фото",
  journeysOpenTrip: "Открыть",
  journeysEntrySaved: "Сохранено",
  journeysPlaces: "Места",
  journeysPlacesHint: "Чеклист мест поездки — отмечайте, что уже посетили",
  journeysPlaceName: "Название места",
  journeysPlaceAdd: "Добавить",
  journeysPlacesEmpty: "Пока нет мест — добавьте первое",
  journeysPlacesShowAll: "Все дни",
  journeysPlaceVisit: "Отметить посещённым",
  journeysPlaceUnvisit: "Снять отметку",
  journeysDayPlaces: "Места этого дня",
  journeysInsertPlaces: "Вставить в запись",
  journeysPlaceDate: "Дата",
  journeysDayPlacesEmpty: "Нет мест на этот день",
  journeysVoiceHint: "Диктовка доступна в Chrome / Edge по HTTPS. Нажмите микрофон под текстом.",
  journeysMapViewList: "Список",
  journeysMapViewMap: "Карта",
  journeysMapAllTags: "Все путешествия",
  journeysMapTagFilter: "Путешествие",
  journeysMapEmpty: "Нет фото с координатами. Откройте поездку и нажмите «На карте» у фото, или загрузите снимок с GPS.",
  journeysMapPlaceOnMap: "На карте",
  journeysMapTapHint: "Нажмите на карту, чтобы поставить точку",
  journeysMapClearLocation: "Сбросить",
  journeysMapPickPoint: "Сначала выберите точку на карте",
  journeysGlobeViewDiary: "Дневник",
  journeysGlobeViewGlobe: "Глобус",
  journeysGlobeNoToken: "Токен Mapbox не настроен в Vault (ключ mytraveldiary_mapbox_token).",
  journeysGlobeEmpty: "Нет маршрутов с координатами и фото с геометками для этой поездки.",
  journeysSegmentDetails: "Детали перемещения",
  journeysSegmentFrom: "Откуда",
  journeysSegmentTo: "Куда",
  journeysShare: "Поделиться",
  journeysShareEnable: "Включить ссылку",
  journeysShareDisable: "Выключить",
  journeysShareCopy: "Копировать ссылку",
  journeysShareCopied: "Ссылка скопирована",
  journeysShareRotate: "Новая ссылка",
  journeysShareHint: "По ссылке видны дневник, фото и карта",
  journeysShareNotFound: "Ссылка недоступна",
  journeysShareNotFoundHint: "Ссылку отключили или она неверная",
  journeysExportPdf: "PDF поездки",
  journeysUploadCover: "Загрузить обложку",
  journeysCoverHint: "Обложку можно загрузить отдельно или выбрать ★ из альбома",
  journeysCurrencyCustom: "Другая",
  journeysImportExpenses: "Из транспорта / отелей",
  journeysImportExpensesHint: "Выберите позиции с этим тегом и ценой",
  journeysImportExpensesEmpty: "Нет непроимпортированных позиций с ценой",
  journeysImportSelected: "Добавить выбранные",
  hotels: "Отели",
  hotelsAdd: "Добавить отель",
  hotelsEdit: "Редактировать отель",
  hotelsEmpty: "Пока нет отелей — добавьте бронь по фото или ссылке",
  carsEmpty: "Пока нет поездок на авто — добавьте маршрут",
  busesEmpty: "Пока нет автобусных поездок — добавьте билет по фото или PDF",
  trainsEmpty: "Пока нет поездок на поезд — добавьте билет по фото или PDF",
  ferriesEmpty: "Пока нет паромных рейсов — добавьте билет по фото или PDF",
  hotelsParseHint: "Распознать бронь: фото/PDF или ссылка",
  hotelsParsePhoto: "Фото брони",
  hotelsParseUrl: "По ссылке",
  hotelsName: "Название",
  hotelsCity: "Город",
  hotelsCountry: "Страна",
  hotelsCheckIn: "Заезд",
  hotelsCheckOut: "Выезд",
  hotelsConfirmation: "Номер брони",
  hotelsUrl: "Ссылка",
  journeysPlacesValidate: "Проверить",
  journeysPlacesValidating: "Проверка…",
  journeysPlacesValidated: "Названия обновлены",
  journeysPlacesFromPlan: "Из плана",
  journeysPlacesImporting: "Импорт…",
  journeysPlacesImported: "Места добавлены из плана",
  journeysPlacesPickPlan: "Выберите сохранённый план",
  journeysPlaceInfo: "Подробнее о месте",
  journeysPlaceInfoLoading: "Генерирую описание…",
  journeysPlaceInfoUnavailable: "Описание недоступно",
  registerCheckEmail: "Аккаунт создан. Подтвердите email по ссылке из письма, затем войдите.",

  tagRequired: "Укажите путешествие",
  tagSelectOrCreate: "Путешествие",

  // Pagination
  previousPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  page: "Страница",
  of: "из",

  adminTitle: "Админка",
  adminSubtitle: "Пользователи и попытки входа",
  adminRefresh: "Обновить",
  adminUsers: "Пользователи",
  adminLoginEvents: "Попытки авторизации",
  adminColStatus: "Статус",
  adminColRole: "Роль",
  adminColCreated: "Создан",
  adminColTime: "Время",
  adminColResult: "Результат",
  adminColReason: "Причина",
  adminActive: "Активен",
  adminInactive: "Отключён",
  adminUnverified: "Не подтверждён",
  adminRoleAdmin: "Админ",
  adminRoleUser: "Пользователь",
  adminLoginOk: "Успех",
  adminLoginFail: "Ошибка",
  adminEmptyUsers: "Пользователей пока нет",
  adminEmptyEvents: "Событий входа пока нет — появятся после логинов",
  adminClearEvents: "Очистить",
  adminClearEventsConfirm: "Удалить все записи о попытках входа?",
  adminReasonPasswordOk: "Пароль",
  adminReasonGoogleOk: "Google",
  adminReasonBadPassword: "Неверный пароль",
  adminReasonUserNotFound: "Пользователь не найден",
  adminReasonRateLimited: "Слишком много попыток",
  adminReasonNoPassword: "Нет пароля",
  adminReasonWrongProvider: "Другой способ входа",
  adminReasonEmailUnverified: "Email не подтверждён",
  adminCountries: "Страны",
  adminTabUsers: "Пользователи",
  adminTabCountries: "Страны",
  adminTabSubdivisions: "Регионы",
  adminAddCountry: "Добавить страну",
  adminAddSubdivision: "Добавить регион",
  adminEditSubdivision: "Редактировать регион",
  adminDeleteSubdivisionConfirm: "Удалить этот регион?",
  adminEmptySubdivisions: "Регионов пока нет",
  adminAllCountries: "Все страны",
  adminColCountry: "Страна",
  adminColType: "Тип",
  adminEditCountry: "Редактировать страну",
  adminDeleteCountry: "Удалить страну",
  adminDeleteCountryConfirm: "Удалить эту страну?",
  adminColIso2: "ISO2",
  adminColNameRu: "Название (RU)",
  adminColNameEn: "Название (EN)",
  adminColRegion: "Регион",
  adminColFlag: "Флаг",
  adminColGroup: "Группа",
  adminColSecondaryFlag: "Второй флаг",
  adminEmptyCountries: "Стран пока нет",
  adminSaveCountry: "Сохранить страну",
  adminFlagUrl: "URL флага",
  adminFlagCode: "Код флага",
  adminTerritoryGroup: "Группа территорий",
  adminSecondaryFlagUrl: "URL второго флага",
  adminSearchCountries: "Поиск по ISO2 или названию…",
  adminClearFlagUrl: "Очистить свой URL флага",
  adminClearSecondaryFlagUrl: "Очистить URL второго флага",

  // Gas station related
  gasStations: "Заправки",
  gasStation: "Заправка",
  addGasStation: "Добавить заправку",
  removeGasStation: "Удалить заправку",
  noGasStations: "Заправки не добавлены для этой поездки.",
  gasStationAndFuel: "Заправка и топливо",
  totalFuelFilled: "Всего заправлено",
  location: "Стоимость топлива",
  enterLocation: "Введите стоимость топлива",
  fuelCost: "Цена топлива (₽/л)",
  enterFuelCost: "Введите цену топлива",
  optional: "необязательно",
  enterFuelAmount: "Введите количество топлива",
  loadingMap: "Загрузка карты..."
} satisfies TranslationKeys;
